'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import I18n from 'I18n';
import useInterval from '../hooks/useInterval';
import { halloweenQuips, defaultQuips } from '../constants/Quips';
import { isHalloween } from '../theming/operators/isHalloween';
import { useTheme } from 'styled-components';
import LanguageUtil from '../util/LanguageUtil';
const quipDelay = 5000;
const ENGLISH_LANG = 'en';
export default (() => {
  const theme = useTheme();
  const quips = isHalloween(theme) ? halloweenQuips : defaultQuips;

  const getQuip = () => {
    const pick = Math.floor(Math.random() * quips.length); // Remove quip so it's not reused and return it

    return quips.length && LanguageUtil.getUserLanguage() === ENGLISH_LANG ? quips.splice(pick, 1) : I18n.text('results.loading.text');
  };

  const [quip, setQuip] = useState(getQuip());
  useInterval(() => setQuip(getQuip()), quipDelay);
  return /*#__PURE__*/_jsx("span", {
    children: quip
  });
});